export default "__VITE_ASSET__CVJ7$rOk__"